import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
//import { UpgradeModule } from '@angular/upgrade/static';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err =>
    console.error(err)
  );
  //.then(platformRef => {
  //  const upgrade = platformRef.injector.get(UpgradeModule);
  //  upgrade.bootstrap(document.body, ['advisorop'], { strictDi: true });
  //});
